import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPopsicle1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPopsicle1"><Path fillRule="evenodd" clipRule="evenodd" d="M5 5C5 2.79086 6.79086 1 9 1H15C17.2091 1 19 2.79086 19 5V18H15V20C15 21.6569 13.6569 23 12 23C10.3431 23 9 21.6569 9 20V18H5V5ZM11 18V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V18H11ZM11 6H9V13H11V6ZM15 6V13H13V6H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPopsicle1;
